import { ReactElement, useEffect, useState } from "react";
import { xProductionBeginAccessorScaled, xProductionEndAccessorScaled } from "../../production/utils";
import KeyValueItem from "../../../components/charts/keyValueItem";
import { formatTimeWithSeconds } from "../../../system/utils";
import { IStrandProduction } from "../../../types";
import { IMillProductDetail } from "../types";
import * as d3 from "d3";
import HtmlTooltip from "../../../components/charts/tooltip";

interface IProps {
  machineKey: string;
  machine: IStrandProduction;
  itemDetail: IMillProductDetail[];
  xScale: d3.ScaleLinear<number, number>;
  h4: number;
}

const ProductionChartCoil = ({ machineKey, machine, itemDetail, xScale, h4 }: IProps): ReactElement => {
  const [ billets, setBillets ] = useState<IMillProductDetail[] | null>(null);

  useEffect(() => {
    setTimeout(() => setBillets(itemDetail), 200);
  }, [itemDetail]);

  const cy = machine.machine.code.toLocaleLowerCase() === "strand1" ? h4 - 5 : h4 * 3 + 5;

  return (
    <g>
      { billets &&
        billets.map((billet, bIndex) => {
          const p1 = xProductionBeginAccessorScaled(billet, xScale);
          const p2 = xProductionEndAccessorScaled(billet, xScale);

          return (
            <g key={`${machineKey}-${billet.billet}-${bIndex}`}
              transform={`translate(${p1}, ${cy})`}>
              <HtmlTooltip title={
                <div>
                  <div className="display-flex-column align-items-center">
                    <strong>Coil</strong>
                    <strong>{machine.machine.name}</strong>
                    {billet.recipe && <strong>{billet.recipe}</strong>}
                    <KeyValueItem name={"Begin"} value={formatTimeWithSeconds(billet.beginDatetime as number)}/>
                    <KeyValueItem name={"End"} value={formatTimeWithSeconds(billet.endDatetime as number)}/>
                    <KeyValueItem name={"Billet"} value={`${billet.billet}`}/>
                    <KeyValueItem name={"Weight"} value={`${billet.weight}`} unit="lb"/>
                  </div>
                </div>
              }>
                <circle cx={(p2 - p1) / 2} cy="0" r="2" fill="gray"/>
              </HtmlTooltip>
            </g>
          );
        })
      }
    </g>);
};


export default ProductionChartCoil;
